const API_URL = process.env.API_URL
const HOST = process.env.API_HOST
const STRIPE_KEY = process.env.STRIPE_KEY
const IDENTITY_POOL_ID = process.env.IDENTITY_POOL_ID
const REGION = process.env.REGION
const USER_POOL_ID = process.env.USER_POOL_ID
const IDENTITY_POOL_REGION = process.env.IDENTITY_POOL_REGION
const USER_POOL_WEB_CLIENT_ID = process.env.USER_POOL_WEB_CLIENT_ID

export default {
  FORMAT_PHONE_NUMBER: formatPhoneNumber,
  API_URL: API_URL,
  STRIPE_KEY: STRIPE_KEY,
  HOST: HOST,
  IDENTITY_POOL_ID: IDENTITY_POOL_ID,
  REGION: REGION,
  USER_POOL_ID: USER_POOL_ID,
  IDENTITY_POOL_REGION: IDENTITY_POOL_REGION,
  USER_POOL_WEB_CLIENT_ID: USER_POOL_WEB_CLIENT_ID,
  STRIPE_KEY: STRIPE_KEY
}

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    var intlCode = (match[1] ? '+1 ' : '')
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
  }
  return phoneNumberString
}


// WEBPACK FOOTER //
// ./src/Constants.js